import { Modal, Button } from "@mui/material";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

const ModalLeaveAlert = (props) => {
  const { isOpen, onClose, onSubmit, isAlertHoliday } = props;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-alert-container">
        <div className="modal-leave-alert-container-wrapper">
          <MDBox className="modal-leave-alert-header">
            <MDBox>
              <MDTypography className="modal-leave-alert-title" variant="h5">
                Alert
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox className="modal-leave-alert-content">
            {isAlertHoliday ? (
              <MDBox className="modal-leave-alert-form">
                This date is a public holiday.
                <br />
                Leave requests are not required.
              </MDBox>
            ) : (
              <MDBox className="modal-leave-alert-form">
                This date is a public holiday. Leave requests are not required.
              </MDBox>
            )}
          </MDBox>
          <MDBox className="modal-leave-alert-footer">
            {isAlertHoliday ? (
              <Button
                variant="outlined"
                onClick={onClose}
                className="submit-button"
                fullWidth
              >
                Close
              </Button>
            ) : (
              <>
                <Button
                  className="submit-button"
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}
                >
                  Still submit
                </Button>
                <Button
                  variant="outlined"
                  onClick={onClose}
                  className="cancel-button"
                >
                  Cancel
                </Button>
              </>
            )}
          </MDBox>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLeaveAlert;
